// extracted by mini-css-extract-plugin
export var numberInputContainer = "_60-0";
export var startPickingButton = "_60-1";